'use strict';

angular.module('shiftTraderApp')
    .controller('ShowDayOffCtrl', function ($scope, user, me, dayOff, $rootScope,
                                            AvailabilityRules, SAErrorHandler, flash, Session,
                                            WorkPeriods, $controller, UserPermissionsService) {
    $scope.me = me;
    $scope.user = user;
    $scope.dayOff  = dayOff;

    $scope.state = {
      rawPermissions: null,
      derivedPermissions: null
    };

    var baseCtrl = $controller('BaseDayOffRequestCtrl', {$scope: $scope});

    var permissionsToLookUp = [
      'days_off.add_message',
      'days_off.add_message_to_mine',
      'days_off.cancel_my_request',
      'days_off.remove',
      'days_off.approve',
      'days_off.disapprove'
    ];

    function processRawPermissions() {
      var rawPerms = $scope.state.rawPermissions;
      var myReq = $scope.dayOff && $scope.dayOff.user && $scope.dayOff.user.id === $scope.me.id;

      $scope.state.derivedPermissions = {
        canSendMessage: rawPerms['days_off.add_message'] || myReq && rawPerms['days_off.add_message_to_mine'],
        canRemove: rawPerms['days_off.remove'],
        canCancel: rawPerms['days_off.cancel_my_request'],
        canApprove: rawPerms['days_off.approve'],
        canDisapprove: rawPerms['days_off.disapprove']
      };
    }

    UserPermissionsService.getCanDict(permissionsToLookUp, 'current')
      .then(function(dikt) {
        $scope.state.rawPermissions = dikt;

        processRawPermissions();
      });


    $scope.commForm = {
      message: ''
    };

    $scope.approveDayOff = function() {
      $scope.dayOff.$approve()
          .then(function(data) {
            console.log(data);
            flash.success = $scope.dayOff.start.format('MMM D, YYYY') + ' to ' + $scope.dayOff._endPrevDay.format('MMM D, YYYY') + ' Approved!';
          }, function(response) {
            console.log('approveBlackoutDate had an error');
            console.log(response);
            SAErrorHandler.processError(response);
          });
    };

    $scope.disapproveDayOff = function() {
      $scope.dayOff.$disapprove()
          .then(function(data) {
            console.log(data);
            flash.success = $scope.dayOff.start.format('MMM D, YYYY') + ' to ' + $scope.dayOff._endPrevDay.format('MMM D, YYYY') + ' dispproved!';
          }, function(response) {
            console.log('disapproveBlackoutDate had an error');
            console.log(response);
            SAErrorHandler.processError(response);
          });
    };

    $scope.cancelDayOff = function() {
      $scope.dayOff.$makeInactive()
          .then(function() {
            flash.success = 'Successfully cancelled day off request.';
            $scope.showCancelledText = true;
          }, function(response) {
            SAErrorHandler.processError(response);
          });
    };

    $scope.removeDayOff = function() {
      $scope.dayOff.$remove()
          .then(function() {
            flash.success = 'Successfully removed day off request.';
          }, function(response) {
            SAErrorHandler.processError(response);
          });
    };

    $scope.sendMessage = function() {
      if ($scope.state.derivedPermissions.canSendMessage) {
        $scope.dayOff.$sendMessage($scope.commForm.message, $scope.me)
            .then(function() {
              $scope.commForm.message = '';
              flash.success = 'Message sent for day off request!';
            }, function(response) {
              console.log('sendMessage had an error');
              console.log(response);
              SAErrorHandler.processError(response);
            });
      }
    };

    $scope.getLinkUrl = function(wp) {
      return '#/workPeriods/' + wp.id;
    };

    baseCtrl.runChecks($scope.dayOff.range_twix, $scope.dayOff);
  });
